import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import ModalVideo from "react-modal-video";

import CircleShape1 from "../../assets/images/shape/circle-shape1.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const CPb = () => {
	const { t } = useTranslation();

	const [isOpen, setIsOpen] = React.useState(true);
	const [display, setDisplay] = React.useState(false);

	const openModal = () => {
		setIsOpen(!isOpen);
	};

	React.useEffect(() => {
		setDisplay(true);
	}, []);

	return (
		<section className="services-area pt-100 pb-70 bg-f1f8fb">
			<React.Fragment>
				{/* If you want to change the video need to update videoID */}
				{display && (
					<ModalVideo
						channel="youtube"
						isOpen={!isOpen}
						videoId="Ex-zxHCJLq8"
						onClose={() => setIsOpen(!isOpen)}
					/>
				)}

				<div className="about-area pb-100">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6 col-md-12">
								<div className="section-title">
									<span className="sub-title">
										<h2>{t("home.CPbh2")}</h2>
										<p align="center">{t("home.CPbp02")}</p>
									</span>
								</div>

								<div className="about-content">
									<h4 align="center">{t("home.CPbh4")}</h4>
									<p align="center">{t("home.CPbp01")}</p>
								</div>
							</div>

							<div className="col-lg-6 col-md-12">
								<div className="about-image">
									<img
										src={CircleShape1}
										alt="circle-shape1"
									/>

									<div className="box">
										<Link
											to="#play-video"
											onClick={(e) => {
												e.preventDefault();
												openModal();
											}}
											className="video-btn popup-youtube"
										>
											<i className="flaticon-google-play"></i>{" "}
											Watch Video
										</Link>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		</section>
	);
};

export default CPb;
